import {useNavigate} from "react-router-dom";
import {useEffect} from "react";

export default function RedirectTo({url = null}) {
    const navigate = useNavigate();


    useEffect(() => {
        if (url && !url.startsWith('http')) {
            navigate(url, {replace: true});
        }

    }, [url]);

    if (url.startsWith('http')) {
        const path = window.location.pathname;

        const secondSlashIndex = path.indexOf('/', 1);

        const result = secondSlashIndex !== -1 ? path.substring(secondSlashIndex + 1) : '';

        window.location.href = url + '/' + result;

        return null
    }


    return null;

};
